import React from 'react';
import PropTypes from 'prop-types';
import SectionHeader from '../../../components_profiles/SectionHeader';
import Project from '../../projects/Project';
import Event from '../../events/Event';
import useActiveQuestionsForUser from '../useActiveQuestionsForUser';
import useActiveInvitationsForUser from '../useActiveInvitationsForUser';
import Loader from '../../../components/Loader';
import useShowMorePagination from '../shared/useShowMorePagination';
import useStableList from '../shared/useStableList';
import usePairedListComposition from '../shared/usePairedListComposition';
import ShowMoreButton from '../shared/ShowMoreButton';

ActiveInvitations.propTypes = {
  user: PropTypes.object.isRequired
};

export default function ActiveInvitations(props) {
  const { user } = props;

  const { showAll, showMore, page, pageSize, totalVisible } = useShowMorePagination();
  const activeProjectsRes = useActiveQuestionsForUser(user, { page, pageSize });
  const activeEventsRes = useActiveInvitationsForUser(user, { page, pageSize });

  const primary = useStableList(activeProjectsRes);
  const secondary = useStableList(activeEventsRes);
  const dataFetching = primary.isFetching || secondary.isFetching;

  const projectsCount = primary.data.length;
  const eventsCount = secondary.data.length;

  const { maxSecondaryToShow: maxEventsToShow, totalExtra } = usePairedListComposition({
    primaryCount: projectsCount,
    secondaryCount: eventsCount,
    primaryTotalCount: primary.meta && primary.meta.totalCount,
    secondaryTotalCount: secondary.meta && secondary.meta.totalCount,
    pageSize: totalVisible,
    showAll,
    isFetching: dataFetching
  });

  function handleShowMore() { showMore(); }

  if (projectsCount > 0 || eventsCount > 0) {
    return (
      <div className="space-y-4">
        <SectionHeader
          title="Active Experiences"
          subtitle="Projects and events that I am currently partnering on."
        />
        <div className="grid grid-cols-1 gap-4">
          {primary.data.map(function(project) {
            return (
              <Project
                key={project.id || project.cid}
                project={project}
              />
            );
          })}
          {maxEventsToShow > 0 && secondary.data.slice(0, maxEventsToShow).map(function(event) {
            return (
              <Event
                key={event.id || event.cid}
                event={event}
              />
            );
          })}
          {totalExtra > 0 && !showAll && (
            <ShowMoreButton count={totalExtra} onClick={handleShowMore} disabled={dataFetching} noun="experiences" />
          )}
          {dataFetching && <Loader />}
        </div>
      </div>
    );
  }

  return null;
}
